





























































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import ApolloClient, { serverBase } from "@/apollo";
import gql from "graphql-tag";
import sceneFragment from "@/fragments/scene";
import { studioModule } from "@/store/studio";
import actorFragment from "@/fragments/actor";
import imageFragment from "@/fragments/image";
import movieFragment from "@/fragments/movie";
import Lightbox from "@/components/Lightbox.vue";
import SceneCard from "@/components/SceneCard.vue";
import MovieCard from "@/components/MovieCard.vue";
import ActorCard from "@/components/Cards/Actor.vue";
import InfiniteLoading from "vue-infinite-loading";
import IActor from "@/types/actor";
import ILabel from "@/types/label";
import studioFragment from "@/fragments/studio";
import IScene from "@/types/scene";
import IMovie from "@/types/movie";
import StudioCard from "@/components/StudioCard.vue";
import LabelSelector from "@/components/LabelSelector.vue";

@Component({
  components: {
    Lightbox,
    SceneCard,
    MovieCard,
    ActorCard,
    InfiniteLoading,
    StudioCard,
    LabelSelector,
  },
  beforeRouteLeave(_to, _from, next) {
    studioModule.setCurrent(null);
    next();
  },
})
export default class StudioDetails extends Vue {
  movies = [] as IMovie[];
  scenes = [] as IScene[];
  actors = [] as IActor[];
  lightboxIndex = null as number | null;

  labelSelectorDialog = false;
  allLabels = [] as ILabel[];
  selectedLabels = [] as number[];
  labelEditLoader = false;

  pluginLoader = false;
  attachUnmatchedScenesLoader = false;

  infiniteId = 0;
  page = 0;

  thumbnailDialog = false;
  thumbnailLoader = false;
  selectedThumbnail = null as File | null;

  labelSearchQuery = "";

  activeTab = 0;

  uploadThumbnail() {
    if (!this.currentStudio) return;

    this.thumbnailLoader = true;

    ApolloClient.mutate({
      mutation: gql`
        mutation($file: Upload!, $name: String, $studio: String, $lossless: Boolean) {
          uploadImage(file: $file, name: $name, studio: $studio, lossless: $lossless) {
            ...ImageFragment
          }
        }
        ${imageFragment}
      `,
      variables: {
        file: this.selectedThumbnail,
        name: this.currentStudio.name + " (thumbnail)",
        studio: this.currentStudio._id,
        lossless: true,
      },
    })
      .then((res) => {
        const image = res.data.uploadImage;
        this.setAsThumbnail(image._id);
        this.thumbnailDialog = false;
        this.selectedThumbnail = null;
      })
      .finally(() => {
        this.thumbnailLoader = false;
      });
  }

  openThumbnailDialog() {
    this.thumbnailDialog = true;
  }

  get currentStudio() {
    return studioModule.current;
  }

  async fetchPage() {
    if (!this.currentStudio) return;

    try {
      const result = await ApolloClient.query({
        query: gql`
          query($query: SceneSearchQuery!) {
            getScenes(query: $query) {
              items {
                ...SceneFragment
                actors {
                  ...ActorFragment
                }
                studio {
                  _id
                  name
                }
              }
            }
          }
          ${sceneFragment}
          ${actorFragment}
        `,
        variables: {
          query: {
            page: this.page,
            studios: [this.currentStudio._id],
            sortDir: "desc",
            sortBy: "addedOn",
          },
        },
      });

      return result.data.getScenes.items;
    } catch (err) {
      throw err;
    }
  }

  runPlugins() {
    if (!this.currentStudio) return;
    this.pluginLoader = true;
    ApolloClient.mutate({
      mutation: gql`
        mutation($id: String!) {
          runStudioPlugins(id: $id) {
            ...StudioFragment
            numScenes
            labels {
              _id
              name
            }
            thumbnail {
              _id
            }
            parent {
              _id
              name
              labels {
                _id
                name
              }
            }
            substudios {
              ...StudioFragment
              numScenes
              labels {
                _id
                name
              }
              thumbnail {
                _id
              }
            }
          }
        }
        ${studioFragment}
      `,
      variables: {
        id: this.currentStudio._id,
      },
    })
      .then((res) => {
        studioModule.setCurrent(res.data.runStudioPlugins);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.pluginLoader = false;
      });
  }

  attachUnmatchedScenes() {
    if (!this.currentStudio) return;
    this.attachUnmatchedScenesLoader = true;
    ApolloClient.mutate({
      mutation: gql`
        mutation($id: String!) {
          attachStudioToUnmatchedScenes(id: $id) {
            ...StudioFragment
            numScenes
            labels {
              _id
              name
            }
            thumbnail {
              _id
            }
            parent {
              _id
              name
              labels {
                _id
                name
              }
            }
            substudios {
              ...StudioFragment
              numScenes
              labels {
                _id
                name
              }
              thumbnail {
                _id
              }
            }
          }
        }
        ${studioFragment}
      `,
      variables: {
        id: this.currentStudio._id,
      },
    })
      .then((res) => {
        studioModule.setCurrent(res.data.attachStudioToUnmatchedScenes);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.attachUnmatchedScenesLoader = false;
      });
  }

  infiniteHandler($state) {
    this.fetchPage().then((items) => {
      if (items.length) {
        this.page++;
        this.scenes.push(...items);
        $state.loaded();
      } else {
        $state.complete();
      }
    });
  }

  setAsThumbnail(id: string) {
    if (!this.currentStudio) return;

    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $opts: StudioUpdateOpts!) {
          updateStudios(ids: $ids, opts: $opts) {
            thumbnail {
              _id
            }
          }
        }
      `,
      variables: {
        ids: [this.currentStudio._id],
        opts: {
          thumbnail: id,
        },
      },
    })
      .then((res) => {
        studioModule.setThumbnail(id);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  updateStudioLabels(labels: ILabel[]) {
    if (!this.currentStudio) return Promise.reject();

    return ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $opts: StudioUpdateOpts!) {
          updateStudios(ids: $ids, opts: $opts) {
            labels {
              _id
              name
              aliases
            }
          }
        }
      `,
      variables: {
        ids: [this.currentStudio._id],
        opts: {
          labels: labels.map((l) => l._id),
        },
      },
    })
      .then((res) => {
        studioModule.setLabels(res.data.updateStudios[0].labels);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  editLabels() {
    if (!this.currentStudio) return;

    this.labelEditLoader = true;
    return this.updateStudioLabels(this.selectedLabels.map((i) => this.allLabels[i]))
      .then((res) => {
        this.labelSelectorDialog = false;
      })
      .finally(() => {
        this.labelEditLoader = false;
      });
  }

  openLabelSelector() {
    if (!this.currentStudio) return;

    if (!this.allLabels.length) {
      ApolloClient.query({
        query: gql`
          {
            getLabels {
              _id
              name
              aliases
            }
          }
        `,
      })
        .then((res) => {
          if (!this.currentStudio) return;

          this.allLabels = res.data.getLabels;
          this.selectedLabels = this.currentStudio.labels.map((l) =>
            this.allLabels.findIndex((k) => k._id == l._id)
          );
          this.labelSelectorDialog = true;
        })
        .catch((err) => {
          console.error(err);
        });
    } else {
      this.labelSelectorDialog = true;
    }
  }

  get thumbnail() {
    if (this.currentStudio && this.currentStudio.thumbnail)
      return `${serverBase}/media/image/${
        this.currentStudio.thumbnail._id
      }?password=${localStorage.getItem("password")}`;
    return `${serverBase}/broken`;
  }

  @Watch("$route.params.id")
  onRouteChange() {
    studioModule.setCurrent(null);
    this.movies = [];
    this.scenes = [];
    this.selectedLabels = [];
    this.page = 0;
    this.onLoad();
  }

  @Watch("activeTab")
  onTabChange(val: number) {
    if (val === 2 && !this.movies.length) this.loadMovies();
    if (val === 3 && !this.actors.length) this.loadActors();
  }

  loadActors() {
    ApolloClient.query({
      query: gql`
        query($id: String!) {
          getStudioById(id: $id) {
            actors {
              ...ActorFragment
              thumbnail {
                _id
                color
              }
              labels {
                _id
                name
              }
            }
          }
        }
        ${actorFragment}
      `,
      variables: {
        id: (<any>this).$route.params.id,
      },
    }).then((res) => {
      this.actors = res.data.getStudioById.actors;
    });
  }

  loadMovies() {
    ApolloClient.query({
      query: gql`
        query($id: String!) {
          getStudioById(id: $id) {
            movies {
              ...MovieFragment
              actors {
                ...ActorFragment
              }
              scenes {
                ...SceneFragment
              }
              studio {
                ...StudioFragment
              }
            }
          }
        }
        ${movieFragment}
        ${actorFragment}
        ${sceneFragment}
        ${studioFragment}
      `,
      variables: {
        id: (<any>this).$route.params.id,
      },
    }).then((res) => {
      this.movies = res.data.getStudioById.movies;
    });
  }

  onLoad() {
    ApolloClient.query({
      query: gql`
        query($id: String!) {
          getStudioById(id: $id) {
            ...StudioFragment
            numScenes
            labels {
              _id
              name
            }
            thumbnail {
              _id
            }
            parent {
              _id
              name
              labels {
                _id
                name
              }
            }
            substudios {
              ...StudioFragment
              numScenes
              labels {
                _id
                name
              }
              thumbnail {
                _id
              }
            }
          }
        }
        ${studioFragment}
      `,
      variables: {
        id: (<any>this).$route.params.id,
      },
    }).then((res) => {
      studioModule.setCurrent(res.data.getStudioById);
    });
  }

  beforeMount() {
    this.onLoad();
  }
}
